<template>
<div class="chapter">
<div class="inner_page">
<h2 class="h2"><a id="page_5"></a><em><strong>Contents</strong></em></h2>
<p class="toc"><a href="#/html/9780292747364_06_ack#ack">ACKNOWLEDGMENTS</a></p>
<p class="toc"><a href="#/html/9780292747364_07_int#int">INTRODUCTION</a></p>
<p class="toc-chap"><a href="#/html/9780292747364_09_ch1#ch1">CHAPTER 1</a></p>
<p class="toc1"><a href="#/html/9780292747364_09_ch1#ch1">WHY NATIVES?</a></p>
<p class="toc1"><a href="#/html/9780292747364_08_hlf1#lev1">MAP OF DESERT REGIONS</a></p>
<p class="toc1"><a href="#/html/9780292747364_09_ch1#lev2">WEATHER OF DESERT CITIES TABLE</a></p>
<p class="toc-chap"><a href="#/html/9780292747364_10_ch2#ch2">CHAPTER 2</a></p>
<p class="toc1"><a href="#/html/9780292747364_10_ch2#ch2">GROWING NATIVE PLANTS</a></p>
<p class="toc1"><a href="#/html/9780292747364_10_ch2#lev3">PLANTING AND STAKING DIAGRAMS</a></p>
<p class="toc1"><a href="#/html/9780292747364_10_ch2#lev4">TREE AND SHRUB PRUNING DIAGRAMS</a></p>
<p class="toc-chap"><a href="#/html/9780292747364_11_ch3#ch3">CHAPTER 3</a></p>
<p class="toc1"><a href="#/html/9780292747364_11_ch3#ch3">WILDFLOWERS</a></p>
<p class="toc1"><a href="#/html/9780292747364_11_ch3#lev5">WILDFLOWER TABLE</a></p>
<p class="toc-chap"><a href="#/html/9780292747364_12_ch4#ch4">CHAPTER 4</a></p>
<p class="toc1"><a href="#/html/9780292747364_12_ch4#ch4">REVEGETATION</a></p>
<p class="toc-chap"><a href="#/html/9780292747364_13_ch5#ch5">CHAPTER 5</a></p>
<p class="toc1"><a href="#/html/9780292747364_13_ch5#ch5">PLANT DESCRIPTIONS</a></p>
<p class="toc"><span href="#/html/9780292747364_14_appa#appa" title="Link target outside of Sample">APPENDIX A PLANTS FOR SPECIFIC USES</span></p>
<p class="toca"><span href="#/html/9780292747364_15_appb#appb" title="Link target outside of Sample">APPENDIX B RESOURCES</span></p>
<p class="toc"><span href="#/html/9780292747364_16_bib#bib" title="Link target outside of Sample">BIBLIOGRAPHY</span></p>
<p class="toc"><span href="#/html/9780292747364_17_ind#ind" title="Link target outside of Sample">INDEX</span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 9780292747364_04_toc.vue?f9b070d6